import styles from "./styles.module.css"

export const AdminLoader = () => {
    return <div className={styles.loaderWrapper}><span className={styles.loader} /></div>
};